import React, { useState } from "react";
import { Typography } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { motion } from "motion/react";


const WorkXPCard = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 800px)" });
  const [workImg, setWorkImg] = useState(props.workImg);
  const [workTitle, setWorkTitle] = useState(props.workTitle);
  const [workCompany, setWorkCompany] = useState(props.workCompany);
  const [workDescrption, setWorkDescription] = useState(props.workDescrption);

  const image = require(`../../assets/img/${workImg}`)

  return (
    <>
      <div
        style={{
          width: "100%",
          height: isTabletOrMobile ? "800px" : "450px",
          display: "flex",
          backgroundColor: "black",
          justifyContent: "space-between",
          boxShadow: "8px 5px 15px rgb(118, 115, 115)"
        }}
      >
        <div style={{ width: isTabletOrMobile ? "100%" : "30%" }}>
          <img src={image} style={{ width: "100%", height: "100%" }} />
        </div>
      </div>
      <div
        style={{
          width: isTabletOrMobile ? "100%" : "95%",
          height: isTabletOrMobile ? "800px" : "450px",
          display: "flex",
          justifyContent: "flex-end",
          position: "absolute",
          backgroundColor: isTabletOrMobile ? "black" : "",
          opacity: isTabletOrMobile ? 0.9 : "",
        }}
      >
        <div
          style={{
            width: isTabletOrMobile ? "100%" : "65%",
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-start",
            textAlign: "left",
            flexDirection: "column",
          }}
        >
          <Typography
            style={{
              color: "white",
              marginTop: "40px",
              marginRight: "20px",
              marginLeft: "20px",
              marginBottom: isTabletOrMobile ? "30px" : "20px",
              fontFamily: "Tenorite",
              fontWeight: "700",
              fontSize: isTabletOrMobile ? "50px" : "60px",
              textAlign: isTabletOrMobile ? "center" : "",
              lineHeight: isTabletOrMobile ? 1.2 : 1,
            }}
          >
            <motion.span
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
            >
              {workTitle}
            </motion.span>
          </Typography>
          <Typography
            style={{
              color: "white",
              fontFamily: "Tenorite",   
              marginRight: "20px",
              marginLeft: "20px",
              fontSize: "20px",
              marginTop: "-13px",
              textAlign: isTabletOrMobile ? "center" : "",
            }}
          >
            <motion.span
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
            >
              {workCompany}
            </motion.span>
          </Typography>
          <Typography
            style={{
              color: "white",
              marginRight: "20px",
              marginLeft: "20px",
              fontFamily: "Tenorite",
              fontSize: isTabletOrMobile ? "22px" : "20px",
              marginTop: "40px",
              textAlign: isTabletOrMobile ? "center" : "justify",
            }}
          >
            <motion.span
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
            >
              {workDescrption}
            </motion.span>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default WorkXPCard;
